/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {materialDark} from 'react-syntax-highlighter/dist/esm/styles/prism'

const AdvanceTab = ({deviceData}) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value || '').then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1000)
    })
  }

  return (
    <>
      <div className='mb-5'>
        <div className='row mb-5'>
          <div className='col-12'>
            <div className='row mb-5'>
              <label className='col-lg-4 fw-bold text-muted'>Public Key</label>
              <div className='col-lg-8'>
                <SyntaxHighlighter language='plaintext' style={materialDark} wrapLongLines>
                  {deviceData?.publicKey}
                </SyntaxHighlighter>

                <button
                  type='button'
                  className='btn btn-sm btn-light-primary'
                  onClick={() => handleCopy(deviceData?.publicKey)}
                >
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
            </div>

            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Private Key</label>
              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  <SyntaxHighlighter language='plaintext' style={materialDark} wrapLongLines>
                    {deviceData?.privateKey}
                  </SyntaxHighlighter>
                  <button
                    type='button'
                    className='btn btn-sm btn-light-primary'
                    onClick={() => handleCopy(deviceData?.privateKey)}
                  >
                    {copied ? 'Copied!' : 'Copy'}
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {AdvanceTab}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
